import Vue from 'vue'
import Router from 'vue-router'
import Main from '@/views/home/Main'
Vue.use(Router);

// const originalPush = Router.prototype.push

// Router.prototype.push = function push (location) {

// return originalPush.call(this, location).catch(err => err)

// }
export const constantRouterMap = [
  {
    path: '/',
    name: '当前位置',
    component: () =>
      import('@/components/Maincontent'),
    children: [
      {
        path: '/appidManage',
        name: 'AppID管理',
        component: Main,
        icon: 'ios-folder',
        // component: () => import('@/views/appidManage/appidManage'),
        // meta: {icon: 'android-folder', title: 'AppID管理'}, //设置role，登录的账号有对应的role才会显示此路由
        children: [{
          path: '/appidList',
          name: 'AppID管理',
          icon: 'android-folder',
          component: () =>
            import('@/views/appidManage/appidManage'),
        },]
      },
      {
        path: '/useManage',
        name: '用户管理',
        component: Main,
        icon: 'ios-folder',
        meta: { role: [1] },
        // component: () => import('@/views/useManage/useManage'),
        // meta: {icon: 'android-folder', title: '用户管理',role:1 }, //设置role，登录的账号有对应的role才会显示此路由
        children: [{
          path: '/useList',
          name: '用户管理',
          icon: 'android-folder',
          meta: { role: [1] },
          component: () =>
            import('@/views/useManage/useManage'),
        },]
      },
      {
        path: '/versionManage',
        name: '版本管理',
        component: Main,
        icon: 'ios-folder',
        // component: () => import('@/views/versionManage/versionManage'),
        // meta: {icon: 'android-folder', title: '版本管理'}, //设置role，登录的账号有对应的role才会显示此路由
        children: [{
          path: '/versionList',
          name: '版本管理',
          icon: 'android-folder',
          component: () =>
            import('@/views/versionManage/versionManage'),
        }, {
          path: '/appGroundManage',
          name: 'APP上架管理',
          icon: 'android-folder',
          component: () =>
            import('@/views/versionManage/appGroundManage'),
        }, {
          path: '/appGroundRecord',
          name: 'APP上架记录',
          icon: 'android-folder',
          component: () =>
            import('@/views/versionManage/appGroundRecord'),
        }, {
          path: '/appLists',
          name: 'APP列表',
          icon: 'android-folder',
          component: () =>
            import('@/views/versionManage/appList'),
        }, {
          path: '/appListingLog',
          name: 'APP上架日志',
          icon: 'android-folder',
          component: () =>
            import('@/views/versionManage/appListingLog'),
        },]
      },
      {
        path: '/useManage',
        name: '文档管理',
        component: Main,
        icon: 'ios-folder',
        meta: { role: [1] },
        // component: () => import('@/views/useManage/useManage'),
        // meta: {icon: 'android-folder', title: '用户管理',role:1 }, //设置role，登录的账号有对应的role才会显示此路由
        children: [{
          path: '/operationDocument',
          name: '操作文档',
          icon: 'android-folder',
          component: () =>
            import('@/views/documentManagement/operationDocument'),
        }, {
          path: '/APIDocumentation',
          name: '接入文档',
          icon: 'android-folder',
          component: () =>
            import('@/views/documentManagement/APIDocumentation'),
        }, {
          path: '/accessDocument',
          name: '接口文档',
          icon: 'android-folder',
          component: () =>
            import('@/views/documentManagement/accessDocument'),
        }, {
          path: '/documentList',
          name: '文档列表',
          icon: 'android-folder',
          component: () =>
            import('@/views/documentManagement/index.vue'),
        }]
      },
      {
        path: '/statistics',
        name: '统计分析',
        component: Main,
        icon: 'ios-folder',
        meta: { role: [1] },
        children: [{
          path: '/statisticsList',
          name: '接口调用统计',
          icon: 'android-folder',
          component: () => import('@/views/statistics/index.vue'),
        }]
      },
    ]
  },
  { path: '/login', name: '登录', component: () => import('@/views/login/login'), },
  { path: '*', redirect: '/useManage' },
  { path: '/webDownload', name: '电脑端下载页', component: () => import('@/views/webDownload/index'), },
  { path: '/appDownload', name: '手机端下载页', component: () => import('@/views/appDownload/index'), },
  { path: '/scanQRCodes', name: '三合一码', component: () => import('@/views/scanCode/indexPage.vue'), },
  { path: '/cameraPhone', name: '扫码', component: () => import('@/views/scanCode/cameraPhone.vue'), },
  { path: '/electronicManual', name: '电子说明书', component: () => import('@/views/scanCode/electronicManual.vue'), },
  {
    path: '/applist',
    name: 'AppList',
    component: () => import('@/views/applist/index.vue'),
    children: [
      {
        path: '',
        name: 'list',
        component: () => import('@/views/applist/list.vue'),
      },
      {
        path: '/applist/:appName?/history', // 动态路径参数
        name: 'history',
        component: () => import('@/views/applist/history.vue'),
        props: true // 允许将参数作为props传递给Download组件
      },
      {
        path: '/applist/:appName?', // 动态路径参数
        name: 'download',
        component: () => import('@/views/applist/download.vue'),
        props: true // 允许将参数作为props传递给Download组件
      },
    ]
  },
];
export default new Router({
  // mode: 'hash',
  mode: 'history',
  routes: constantRouterMap
})



// WEBPACK FOOTER //
// ./src/router/index.js